module.exports = __webpack_public_path__ + "img/homebg02.45d60756.svg";